import "./Paper.scss";

const Paper = ({ children }) => (
  <div className="oca-paper-root">
    <div className="oca-paper">{children}</div>
  </div>
);

export default Paper;
